// Shared dock-visibility rules. BottomDock uses these to decide whether
// to render at all; MobileFrame uses them to decide whether to reserve
// padding-bottom for the dock space. Without sharing, MobileFrame
// reserves a 56+safe-area band on routes where the dock is hidden,
// pushing page content (e.g. the DM composer) below the viewport.

const HIDDEN_ROUTES = new Set([
  "/", "/auth", "/waitlist", "/signup", "/auth/callback",
  "/onboard", "/tutorial", "/scan", "/analyze", "/post", "/post/quick",
]);

const HIDDEN_PREFIXES = ["/messages/"];

export function isDockHidden(pathname: string): boolean {
  if (HIDDEN_ROUTES.has(pathname)) return true;
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return true;
  return false;
}
